
import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  LOAN_DETAIL_CHANGED,
  UPDATE_COMMITMENTS_SUCCESS,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_LOAN_DETAIL_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
} from '../../actions/types'

const INIT_STATE = 'variable'

const interestType = (state=INIT_STATE, {type, payload}) => {
  switch(type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      if ( payload.applicationFlow.loanDetail !== undefined ) {
        return payload.applicationFlow.loanDetail.interestType || state
      } else {
        return state
      }

    case UPDATE_COMMITMENTS_SUCCESS:
    case UPDATE_ASSETS_SUCCESS:
    case UPDATE_LOAN_DETAIL_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      if (payload.loanDetail !== undefined ) {
        return payload.loanDetail.interestType || state
      } else {
        return state
      }

    case LOAN_DETAIL_CHANGED:
      return payload.interestType || state

    default:
      return state
  }
}

export default interestType
